
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.43 5.21a9 9 0 107.72 13.62M13.43 23.16v36M13.28 40.12H5.55v5.04h3v5h-5v5h9.88","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('circle',{attrs:{"cx":"21.57","cy":"9.84","r":"9","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M28.52 15.48l27.93 22.69M41.01 25.84l-5.34 6.57 4.29 3.49 2.07-2.56 4.26 3.46-3.46 4.25 4.26 3.46 6.82-8.41"}})])
          )
        }
      }
    